import React, {Component} from 'react'
import {
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
} from '@material-ui/core'
import {Mutation, Query} from 'react-apollo'
import {toast} from 'react-toastify'

import {get} from 'lodash'
import {Formik} from 'formik'
import * as yup from 'yup'

import {requireAuthAndProject} from '../../../../auth'
import {FusePageCarded} from '../../../../@fuse'
import {USER} from '../../../../graphql/query'
import {CHANGE_PASSWORD} from '../../../../graphql/mutation'
import {setLoginToken} from '../../../../utils'

import {
  FormikTextField,
  GridItem,
} from '../ecommerce/storeSettings/components/common'

class ProfilePage extends Component {
  constructor(props) {
    super(props)
    this.validationSchema = yup.object({
      oldPassword: yup.string().required('กรุณากรอกรหัสผ่านเดิม'),
      newPassword: yup
        .string()
        .min(6, 'ขั้นตำ่ 6 ตัวอักษร')
        .required('กรุณากรอก รหัสใหม่'),
      confirmNewPassword: yup
        .string()
        .min(6, 'ขั้นตำ่ 6 ตัวอักษร')
        .oneOf([yup.ref('newPassword'), null], 'รหัสใหม่ ไม่ตรงกัน')
        .required('กรุณากรอก ยืนยันรหัสใหม่'),
    })
  }

  render() {
    const header = (
      <div className="flex items-center p-8 md:p-24">
        <img
          style={{
            width: '50px',
          }}
          className="text-32 mr-12"
          alt=""
          src="./assets/images/deeple/7_setting_white.png"
        />
        <Typography variant="title">ข้อมูลส่วนตัว</Typography>
      </div>
    )

    const content = (
      <div style={{padding: 24}}>
        <Query query={USER}>
          {({loading, error, data}) => {
            const myEmail = get(data, 'me.email', '')
            const myFirstName = get(data, 'me.firstname', '')
            const myLastName = get(data, 'me.lastname', '')
            return (
              <React.Fragment>
                <Card>
                  <CardContent>
                    <Grid container spacing={16}>
                      <Grid item xs={12}>
                        <Typography variant="title">ข้อมูลของฉัน</Typography>
                        <Grid
                          container
                          justify="flex-start"
                          alignItems="center"
                          spacing={16}
                        >
                          <Grid item>
                            <TextField
                              label="อีเมล์"
                              value={myEmail}
                              margin="normal"
                              variant="outlined"
                              fullWidth
                            />
                          </Grid>
                          <Grid item>
                            <TextField
                              label="ชื่อ"
                              value={myFirstName}
                              margin="normal"
                              variant="outlined"
                              fullWidth
                            />
                          </Grid>
                          <Grid item>
                            <TextField
                              label="นามสกุล"
                              value={myLastName}
                              margin="normal"
                              variant="outlined"
                              fullWidth
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          justify="flex-start"
                          alignItems="center"
                          spacing={16}
                          style={{display: 'none'}}
                        >
                          <Grid item>
                            <Button
                              aria-label="Change Infomation"
                              disabled={loading}
                              style={{background: '#663EE8', color: 'white'}}
                            >
                              บันทึก
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                <br />
                <Card>
                  <CardContent>
                    <Grid container spacing={16}>
                      <Grid item xs={12}>
                        <Typography variant="title">เปลี่ยนรหัสผ่าน</Typography>
                        <Mutation mutation={CHANGE_PASSWORD}>
                          {changePassword => {
                            return (
                              <Formik
                                enableReinitialize
                                initialValues={{
                                  oldPassword: '',
                                  newPassword: '',
                                  confirmNewPassword: '',
                                }}
                                onSubmit={(
                                  values,
                                  {setSubmitting, resetForm},
                                ) => {
                                  changePassword({
                                    variables: {
                                      email: myEmail,
                                      oldPassword: values.oldPassword,
                                      newPassword: values.newPassword,
                                    },
                                  })
                                    .then(result => {
                                      if (
                                        result.data.changePassword !== 'false'
                                      ) {
                                        setLoginToken(
                                          result.data.changePassword,
                                        )
                                        toast.success(
                                          'เปลี่ยนรหัสผ่านสำเร็จแล้ว',
                                          {
                                            position:
                                              toast.POSITION.BOTTOM_RIGHT,
                                          },
                                        )
                                        setSubmitting(false)
                                        resetForm({
                                          oldPassword: '',
                                          newPassword: '',
                                          confirmNewPassword: '',
                                        })
                                      }
                                    })
                                    .catch(changePasswordError => {
                                      changePasswordError.graphQLErrors.forEach(
                                        ({message}) => {
                                          toast.error(message, {
                                            position:
                                              toast.POSITION.BOTTOM_RIGHT,
                                          })
                                          setSubmitting(false)
                                        },
                                      )
                                    })
                                }}
                                validationSchema={this.validationSchema}
                                render={props => (
                                  <form onSubmit={props.handleSubmit}>
                                    <Grid container spacing={16}>
                                      <Grid item xs={12}>
                                        <Grid
                                          container
                                          justify="flex-start"
                                          alignItems="center"
                                          spacing={16}
                                        >
                                          <GridItem item xs={12}>
                                            <FormikTextField
                                              onChange={props.handleChange}
                                              onBlur={props.handleBlur}
                                              value={props.values.oldPassword}
                                              errors={props.errors}
                                              touched={props.touched}
                                              type="password"
                                              name="oldPassword"
                                              label="รหัสผ่านเดิม"
                                              fullWidth
                                            />
                                          </GridItem>
                                          <GridItem item xs={12}>
                                            <FormikTextField
                                              onChange={props.handleChange}
                                              onBlur={props.handleBlur}
                                              value={props.values.newPassword}
                                              errors={props.errors}
                                              touched={props.touched}
                                              type="password"
                                              name="newPassword"
                                              label="รหัสผ่านใหม่"
                                              fullWidth
                                            />
                                          </GridItem>
                                          <GridItem item xs={12}>
                                            <FormikTextField
                                              onChange={props.handleChange}
                                              onBlur={props.handleBlur}
                                              value={
                                                props.values.confirmNewPassword
                                              }
                                              errors={props.errors}
                                              touched={props.touched}
                                              type="password"
                                              name="confirmNewPassword"
                                              label="ยืนยัน รหัสผ่านใหม่"
                                              fullWidth
                                            />
                                          </GridItem>
                                          <Button
                                            variant="raised"
                                            type="submit"
                                            className="w-224 mx-auto mt-16"
                                            aria-label="LOG IN"
                                            disabled={props.isSubmitting}
                                            style={{
                                              background: '#663EE8',
                                              color: 'white',
                                            }}
                                          >
                                            บันทึก
                                          </Button>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </form>
                                )}
                              />
                            )
                          }}
                        </Mutation>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </React.Fragment>
            )
          }}
        </Query>
      </div>
    )

    return <FusePageCarded header={header} content={content} />
  }
}

export default requireAuthAndProject(ProfilePage)



// WEBPACK FOOTER //
// ./src/main/content/project/profile/Profile.js